import React from "react";
import {InfoCircleOutlined} from "@ant-design/icons";
import {Card, Col, Row, Tooltip, Typography} from "antd";
import PropTypes from "prop-types";

import EngageCurrency from "./EngageCurrency";
import {userIsStaff} from "../../lib/role";
import {black, errorRed} from "../../assets/colors";
import {
    accountingBalanceTextMember,
    accountingBalanceTextStaff,
    depositBalanceText,
    payableBalanceText
} from "../../helpers/text";

const {Text} = Typography;

const BalanceInfoCard = ({balanceType, balance}) => {
    let cardText, tooltipText;
    const isStaff = userIsStaff();

    switch (balanceType) {
        case 'accounting':
            cardText = 'Accounting Balance';
            tooltipText = isStaff ? accountingBalanceTextStaff : accountingBalanceTextMember;
            break;
        case 'accrued':
            cardText = 'Account Balance (plus pending)';
            tooltipText = payableBalanceText + ' Accrued balance includes any pending transactions.';
            break;
        case 'overdue':
            cardText = 'Overdue Balance';
            break;
        case 'payable':
            cardText = 'Payable Balance';
            tooltipText = payableBalanceText;
            break;
        case 'deposit':
            cardText = 'Deposit';
            tooltipText = depositBalanceText;
            break;
        case 'promotional credits':
            cardText = 'Total Promotional Credit Balance';
            tooltipText = 'The total Remaining Balance from all non-expired promotional credits.';
            break;
        default:
            cardText = 'Account Balance';
            tooltipText = payableBalanceText;
            break;
    }

    return (
        <Card>
            <Row gutter={[0, 16]}>
                <Col xs={24} md={24}>
                    <Text style={{fontSize: "16px"}} strong>{cardText}</Text>
                    {
                        tooltipText &&
                        <Tooltip title={tooltipText} className="anticon-tooltip">
                            <InfoCircleOutlined/>
                        </Tooltip>
                    }
                </Col>
            </Row>
            <Row gutter={[0, 16]}>
                <Col xs={24} md={24}>
                    <EngageCurrency
                        style={{
                            fontSize: "24px",
                            color: balanceType === 'overdue' && balance > 0 ? errorRed : black,
                        }}
                        amount={balance}
                    />
                </Col>
            </Row>
        </Card>
    );
}

BalanceInfoCard.propTypes = {
    balanceType: PropTypes.string.isRequired,
    balance: PropTypes.number.isRequired,
};

BalanceInfoCard.defaultProps = {
    balance: 0,
}

export default BalanceInfoCard;
